import { render, staticRenderFns } from "./QuickInfo.vue?vue&type=template&id=ae45849e&"
import script from "./QuickInfo.vue?vue&type=script&lang=js&"
export * from "./QuickInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports